import { Timestamp } from 'firebase/firestore';

/**
 * CRM Ideas/Feedback Types
 * 
 * Separate from EOS Ideas - this is for CRM-specific feedback and improvement suggestions.
 */

export interface CRMIdea {
  id: string;
  title: string;
  description: string;
  type: 'idea' | 'fix';
  status: 'new' | 'completed';
  createdBy: string;
  createdByName: string;
  createdByEmail: string;
  completedBy?: string;
  completedByName?: string;
  createdAt: Timestamp;
  completedAt?: Timestamp;
  screenshots?: Screenshot[];
}

export interface Screenshot {
  url: string;
  name: string;
}

// Collection name for CRM Ideas (separate from EOS 'ideas' collection)
export const CRM_IDEAS_COLLECTION = 'crm_ideas';



